import React, {useState, useEffect} from 'react'
import { BsStar, BsStarFill } from 'react-icons/bs'
import './Stars.css'

// let value, mystar = 0
const Star = ({currentrating, status, selectedstar}) => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);

  const handleClicked = (val) =>{
    setRating(val)
    selectedstar(val)
  }
  return (
    <div className="flex justify-center">
      {[...Array(4)].map((_, index) => {
        index += 1;
        return (
          <button
            type="button"
            disabled = {status}
            key={index}
            className={index <= ((rating && hover) || hover) ? "on" : "off"}
            onClick={() => handleClicked(index)}
            onMouseEnter={() => setHover(index)}
            onMouseLeave={() => setHover(rating)}
          >
            <BsStarFill id='star-icons' className="star"/>
          </button>
        );
      })}
    </div>
  );
}

export default Star